"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

var _reactAddonsPureRenderMixin = _interopRequireDefault(require("react-addons-pure-render-mixin"));

var _AccordionTransition = _interopRequireDefault(require("../transitions/AccordionTransition"));

var _times = require("HubStyleTokens/times");

var _Styles = require("../utils/Styles");

var _component = _interopRequireDefault(require("../utils/propTypes/component"));

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  padding-top: 12px;\n  padding-bottom: 12px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  height: auto;\n  transition: ", ";\n  transform: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var EDITABLE_CONTROLS_TRANSITION_TIMEOUT = parseInt(_times.EDITABLE_CONTROLS_TRANSITION_TIMING, 10);
var DRAWER_PADDING_Y = 8;
var SlideoutTransitionWrapper = (0, _styledComponents.default)(_AccordionTransition.default.defaultProps.Wrapper).withConfig({
  displayName: "UISlideoutDrawer__SlideoutTransitionWrapper",
  componentId: "e64zg9-0"
})(_templateObject(), function (_ref) {
  var duration = _ref.duration,
      measuredHeight = _ref.measuredHeight,
      transitionActive = _ref.transitionActive,
      opening = _ref.opening;
  if (!transitionActive || measuredHeight == null) return 'none'; // On slide-down, fade in after a delay. On slide-up, fade out fast right away.

  var opacityDuration = opening ? duration * 0.7 : duration * 0.3;
  var opacityDelay = opening ? duration - opacityDuration : 0;
  return "opacity " + opacityDuration + "ms ease-out " + opacityDelay + "ms, transform " + duration + "ms";
}, function (_ref2) {
  var hidden = _ref2.hidden,
      measuredHeight = _ref2.measuredHeight,
      transitioning = _ref2.transitioning;
  return transitioning && (hidden ? "translateY(" + (0, _Styles.toPx)(-1 * (measuredHeight - DRAWER_PADDING_Y)) + ")" : "translateY(0)");
});

var DrawerContent = _styledComponents.default.div.withConfig({
  displayName: "UISlideoutDrawer__DrawerContent",
  componentId: "e64zg9-1"
})(_templateObject2());

var UISlideoutDrawer = _react.default.createClass({
  displayName: "UISlideoutDrawer",
  mixins: [_reactAddonsPureRenderMixin.default],
  propTypes: {
    Content: _component.default.isRequired,
    onOpenChange: _react.PropTypes.func,
    open: _react.PropTypes.bool,
    children: _react.PropTypes.node
  },
  getDefaultProps: function getDefaultProps() {
    return {
      Content: DrawerContent,
      open: false
    };
  },
  render: function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        Content = _this$props.Content,
        __onOpenChange = _this$props.onOpenChange,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["children", "className", "Content", "onOpenChange"]);
    return _react.default.createElement(_AccordionTransition.default, (0, _extends2.default)({}, rest, {
      className: (0, _classNames.default)('uiEditableControlsStage', className),
      duration: EDITABLE_CONTROLS_TRANSITION_TIMEOUT,
      Wrapper: SlideoutTransitionWrapper
    }), _react.default.createElement(Content, {
      className: "private-slideout-drawer__content"
    }, children));
  }
});

var _default = (0, _Controllable.default)(UISlideoutDrawer, ['open']);

exports.default = _default;
module.exports = exports.default;